module.exports = __webpack_public_path__ + "img/csv.bf1739f8.svg";